export const PREMIUM_TRIAL_CAMPAIGN_SLUG = "ela-sci-ss-trial-2025";

export const PREMIUM_TRIAL_CAMPAIGN_SLUG_LAST_YEAR = "ela-sci-ss-trial-2024";

export const NCE_ALL_ACCESS_TRIAL_CAMPAIGN_TITLE = "NCE-2025-180-AllAccess";

export const NCE_TRIAL_CAMPAIGN_TITLES = [NCE_ALL_ACCESS_TRIAL_CAMPAIGN_TITLE];

export const ACTIVE_TRIAL_LICENSES = [
  PREMIUM_TRIAL_CAMPAIGN_SLUG,
  PREMIUM_TRIAL_CAMPAIGN_SLUG_LAST_YEAR,
  ...NCE_TRIAL_CAMPAIGN_TITLES,
];
